var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"learning_state"},[_c('div',{staticClass:"content"},[_c('h2',[_vm._v("欢迎使用“学习状态测评”！")]),_vm._m(0),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.beginTest}},[_vm._v("开始测评")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',[_vm._v("测评没有对与错之分，根据您的日常实际表现真实做答,不是您期望的理想表现! 有些题目可能您从未碰到过或者难以选择,不要过多思考,凭第一感觉做答。")])])
}]

export { render, staticRenderFns }